import { HOST_URL, APPLICATION_ID } from "../constants";

export default {
  authenticate: async function (refreshToken) {
    return fetch(`${HOST_URL}/auth/api/v2/frontend/auth`, {
      headers: { "content-type": "application/json" },
      method: "POST",
      body: JSON.stringify({
        application_id: APPLICATION_ID,
        refresh_token: refreshToken,
      }),
    });
  },
  login: async function (email, password) {
    return fetch(`${HOST_URL}/auth/api/v2/frontend/login`, {
      headers: { "content-type": "application/json" },
      method: "POST",
      body: JSON.stringify({ application_id: APPLICATION_ID, email, password }),
    });
  },
  logout: async function (refreshToken) {
    return fetch(`${HOST_URL}/auth/api/v2/frontend/logout`, {
      headers: { "content-type": "application/json" },
      method: "POST",
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  },
  refreshJWT: async function (refreshToken) {
    return fetch(`${HOST_URL}/auth/api/v2/frontend/refresh`, {
      headers: { "content-type": "application/json" },
      method: "POST",
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  },
};
